import { Component, computed, effect, input, signal } from '@angular/core';

import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';

import { ProgressSpinner } from 'primeng/progressspinner';
import { ChartModule } from 'primeng/chart';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-basic-chart',
    imports: [CommonModule, ChartModule, ProgressSpinner],
    templateUrl: './basic-chart.component.html',
    styleUrl: './basic-chart.component.scss'
})
export class BasicChartComponent {
    loading = input<boolean>(false);
    providerInformationData = input<IFiltredDashboardResponse['providerInformation']['salesNumber']>();

    totalProvider = computed(() => {
        const data = this.providerInformationData();
        if (!data) return 0;

        return Object.values(data).reduce((sum, val) => sum + val, 0);
    });

    constructor() {
        effect(() => {
            this.updateChartData();
        });
    }

    chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Provider Name',
                    font: { size: 14, weight: 'bold' }
                },
                grid: { display: false }
            },
            y: {
                title: {
                    display: true,
                    text: 'Sales Number',
                    font: { size: 14, weight: 'bold' }
                }
            }
        }
    };

    chartData = signal({
        labels: [''],
        datasets: [
            {
                label: 'Sales Number',
                data: [0],
                backgroundColor: '#1E40AF',
                borderRadius: 5,
                barPercentage: 0.4
            }
        ]
    });

    updateChartData() {
        this.chartData.update((value) => ({
            labels: Object.keys(this.providerInformationData() ?? {}),
            datasets: [
                {
                    ...value.datasets[0],
                    data: Object.values(this.providerInformationData() ?? {})
                }
            ]
        }));
    }
}
